export enum EXTERNAL_PAGE {
  GLOBAL_POSITION = 'GLOBAL_POSITION',
  INDIVIDUAL_VALUATION = 'INDIVIDUAL_VALUATION',
  FUND_DETAIL = 'FUND_DETAIL',
  FIXED_INCOME_DETAIL = 'FIXED_INCOME_DETAIL',
  VARIABLE_INCOME_DETAIL = 'VARIABLE_INCOME_DETAIL',
  PENSION_DETAIL = 'PENSION_DETAIL',
  EPSV_DETAIL = 'EPSV_DETAIL',
  DERIVATIVE_DETAIL = 'DERIVATIVE_DETAIL',
  WARRANT_DETAIL = 'WARRANT_DETAIL',
  ETF_DETAIL = 'ETF_DETAIL',
  CASH_ACCOUNT_DETAIL = 'CASH_ACCOUNT_DETAIL',
  DEPOSIT_DETAIL = 'DEPOSIT_DETAIL',
  CREDIT_DETAIL = 'CREDIT_DETAIL',
  LOAN_DETAIL = 'LOAN_DETAIL',
  CREDIT_CARD_DETAIL = 'CREDIT_CARD_DETAIL',
  DEBIT_CARD_DETAIL = 'DEBIT_CARD_DETAIL',
}

export enum EXTERNAL_TOOL {
  ADVANCED_FUND_SEARCH = 'ADVANCED_FUND_SEARCH',
  MARKET_STATUS_TOOL = 'MARKET_STATUS_TOOL',
  ADVANCED_FIXED_INCOME_SEARCH = 'ADVANCED_FIXED_INCOME_SEARCH',
  ADVANCED_VARIABLE_INCOME_SEARCH = 'ADVANCED_VARIABLE_INCOME_SEARCH',
  ADVANCED_PENSION_SEARCH = 'ADVANCED_PENSION_SEARCH',
  ADVANCED_EPSV_SEARCH = 'ADVANCED_EPSV_SEARCH',
  ADVANCED_DERIVATIVE_SEARCH = 'ADVANCED_DERIVATIVE_SEARCH',
  ADVANCED_WARRANT_SEARCH = 'ADVANCED_WARRANT_SEARCH',
  ADVANCED_ETF_SEARCH = 'ADVANCED_ETF_SEARCH',
  TAX_HISTORY_FUND = 'TAX_HISTORY_FUND',
  // TOOLS PAGE
  CURRENCY_EXCHANGE = 'CURRENCY_EXCHANGE',
  SIMULATED_PORTFOLIO = 'SIMULATED_PORTFOLIO',
  INVESTMENT_ALERTS = 'INVESTMENT_ALERTS',
  VIEW_ANALYSIS_ETF = 'VIEW_ANALYSIS_ETF',
  VIEW_ANALYSIS_VI = 'VIEW_ANALYSIS_VI',
  BALANCE_AND_OPERATION_HISTORY = 'BALANCE_AND_OPERATION_HISTORY',
  // ADVANCED MOVEMENT SEARCH SUB-ITEMS
  SEARCH_ACCOUNT_BALANCES = 'SEARCH_ACCOUNT_BALANCES',
  SEARCH_DEBIT_CARD_MOVEMENTS = 'SEARCH_DEBIT_CARD_MOVEMENTS',
  SEARCH_CREDIT_CARD_MOVEMENTS = 'SEARCH_CREDIT_CARD_MOVEMENTS',
  SEARCH_LOAN_RECEIPTS = 'SEARCH_LOAN_RECEIPTS',
  SEARCH_CREDIT_MOVEMENTS = 'SEARCH_CREDIT_MOVEMENTS',
  SEARCH_DEPOSIT_HISTORY = 'SEARCH_DEPOSIT_HISTORY',
  SEARCH_CASH_ORDERS = 'SEARCH_CASH_ORDERS',
  SEARCH_ORDERS = 'SEARCH_ORDERS',
  SEARCH_OPERATIONS = 'SEARCH_OPERATIONS',
  SEARCH_FINANCIAL_OPERATIONS = 'SEARCH_FINANCIAL_OPERATIONS',
  CYBERSECURITY = 'CYBERSECURITY',
  // ACCOUNTS ACTIONS
  VIEW_PORTFOLIO_PERFORMANCE = 'VIEW_PORTFOLIO_PERFORMANCE',
  VIEW_TRANSACTIONS = 'VIEW_TRANSACTIONS',
  VIEW_ORDERS = 'VIEW_ORDERS',
  VIEW_FINANCIAL_OPERATIONS = 'VIEW_FINANCIAL_OPERATIONS',
  MANAGE_AUTHORIZED_USERS = 'MANAGE_AUTHORIZED_USERS',
  PORTFOLIO_ANALYSIS = 'PORTFOLIO_ANALYSIS',
  TRANSFER = 'TRANSFER',
  SUBSCRIBE = 'SUBSCRIBE',
  REDEEM = 'REDEEM',
  LEGAL_DOCUMENTS = 'LEGAL_DOCUMENTS',
  VIEW_AWM_FUNDS = 'VIEW_AWM_FUNDS',
  NAV_HISTORY_EPSV = 'NAV_HISTORY_EPSV',
  NAV_HISTORY_PENSION = 'NAV_HISTORY_PENSION',
  NAV_HISTORY_FUND = 'NAV_HISTORY_FUND',
  VIEW_PROFIT_AND_LOSS = 'VIEW_PROFIT_AND_LOSS',
  TAX_HISTORY = 'TAX_HISTORY',
  FUND_TRANSFER = 'FUND_TRANSFER',
  // FIXED INCOME ACTIONS
  MODIFY_REPO = 'MODIFY_REPO',
  BUY_REPO = 'BUY_REPO',
  PRICE_HISTORY = 'PRICE_HISTORY',
  PRICE_HISTORY_FI = 'PRICE_HISTORY_FI',
  // VARIABLE INCOME ACTIONS
  BUY_SHARES = 'BUY_SHARES',
  SELL_SHARES = 'SELL_SHARES',
  VIEW_ANALYSIS = 'VIEW_ANALYSIS',
  VIEW_PRODUCT_DETAILS = 'VIEW_PRODUCT_DETAILS',
  BUY_RV = 'BUY_RV',
  SELL_RV = 'SELL_RV',
  VIEW_PRODUCT_DETAILS_VI = 'VIEW_PRODUCT_DETAILS_VI',
  PRICE_HISTORY_VI = 'PRICE_HISTORY_VI',
  TAX_HISTORY_VI = 'TAX_HISTORY_VI',
  // PENSION / EPSV ACTIONS
  MAKE_CONTRIBUTION = 'MAKE_CONTRIBUTION',
  MAKE_CONTRIBUTION_EPSV = 'MAKE_CONTRIBUTION_EPSV',
  PENSION_TRANSFER = 'PENSION_TRANSFER',
  EPSV_TRANSFER = 'EPSV_TRANSFER',
  PROCESS_RESCUE = 'PROCESS_RESCUE',
  PROCESS_RESCUE_EPSV = 'PROCESS_RESCUE_EPSV',
  MANAGE_CONTRIBUTIONS = 'MANAGE_CONTRIBUTIONS',
  VIEW_CONTRIBUTIONS = 'VIEW_CONTRIBUTIONS',
  // DERIVATIVE ACTIONS
  BUY_DERIVATIVE = 'BUY_DERIVATIVE',
  SELL_DERIVATIVE = 'SELL_DERIVATIVE',
  VIEW_WARRANTY = 'VIEW_WARRANTY',
  VIEW_FIFOS_WTS = 'VIEW_FIFOS_WTS',
  VIEW_FIFOS_DE = 'VIEW_FIFOS_DE',
  PRICE_HISTORY_DE = 'PRICE_HISTORY_DE',
  VIEW_OPEN_POSITION_DETAILS = 'VIEW_OPEN_POSITION_DETAILS',
  // WARRANT ACTIONS
  BUY_WARRANT = 'BUY_WARRANT',
  SELL_WARRANT = 'SELL_WARRANT',
  VIEW_PRODUCT_DETAILS_WTS = 'VIEW_PRODUCT_DETAILS_WTS',
  TAX_HISTORY_WTS = 'TAX_HISTORY_WTS',
  PRICE_HISTORY_WTS = 'PRICE_HISTORY_WTS',
  // ETF ACTIONS
  BUY_ETFS = 'BUY_ETFS',
  SELL_ETFS = 'SELL_ETFS',
  VIEW_FUND_DETAILS = 'VIEW_FUND_DETAILS',
  VIEW_PENSION_DETAILS = 'VIEW_PENSION_DETAILS',
  VIEW_ETF_DETAILS = 'VIEW_ETF_DETAILS',
  PRICE_HISTORY_ETF = 'PRICE_HISTORY_ETF',
  // CASH ACCOUNT ACTIONS
  RETENTIONS_DETAILS = 'RETENTIONS_DETAILS',
  // MAILBOX ACTIONS
  OPERATION_STATEMENTS = 'OPERATION_STATEMENTS',
  // DEPOSIT ACTIONS
  DEPOSIT_MODIFY_CONDITIONS = 'DEPOSIT_MODIFY_CONDITIONS',
  CANCEL_DEPOSIT = 'CANCEL_DEPOSIT',
  // CARD ACTIONS
  CREDIT_CARD_MODIFY_CONDITIONS = 'CREDIT_CARD_MODIFY_CONDITIONS',
  DEBIT_CARD_MODIFY_CONDITIONS = 'DEBIT_CARD_MODIFY_CONDITIONS',
  // CREDIT ACTIONS
  CHANGE_CREDIT_RENEWAL = 'CHANGE_CREDIT_RENEWAL',
  CONSULT_INE_CONDITIONS = 'CONSULT_INE_CONDITIONS',
  VIEW_WARRANTIES = 'VIEW_WARRANTIES',
  LOWER_CREDIT_LIMIT = 'LOWER_CREDIT_LIMIT',
  CANCEL_CREDIT = 'CANCEL_CREDIT',
  // MY DOCUMENTS
  FISCAL_INFORMATION = 'FISCAL_INFORMATION',
  COMMISSION_INFORMATION = 'COMMISSION_INFORMATION',
  // PERSONAL AREA
  CHANGE_SIGNATURE = 'CHANGE_SIGNATURE',
  // PERSONAL AREA - MY ACCOUNTS
  MODIFY_COMMUNICATION_CHANNELS = 'MODIFY_COMMUNICATION_CHANNELS',
  MODIFY_CORRESPONDENCE_DATA = 'MODIFY_CORRESPONDENCE_DATA',
  MANAGE_THIRD_PARTY_ACCESS = 'MANAGE_THIRD_PARTY_ACCESS',
  // PRODUCTS - contratacion
  DEBIT_VISA = 'DEBIT_VISA',
  PLATINUM_VISA = 'PLATINUM_VISA',
  GOLD_VISA = 'GOLD_VISA',
  DEPOSITS = 'DEPOSITS',
  SECURITIES_ACCOUNT = 'SECURITIES_ACCOUNT',
  ONLINE_QUOTES = 'ONLINE_QUOTES',
  INVESTMENT_FUNDS = 'INVESTMENT_FUNDS',
  ETFS = 'ETFS',
  EQUITIES = 'EQUITIES',
  FIXED_INCOME = 'FIXED_INCOME',
  PENSION_PLAN = 'PENSION_PLAN',
  EPSV = 'EPSV',
  DERIVATIVES_ACCOUNT = 'DERIVATIVES_ACCOUNT',
  DERIVATIVES = 'DERIVATIVES',
  WARRANTS = 'WARRANTS',
  // PRODUCTS - listados
  VIEW_DIRECT_DEBITS = 'VIEW_DIRECT_DEBITS',
  RETURN_RECEIPTS = 'RETURN_RECEIPTS',
  MANAGE_DIRECT_DEBITS = 'MANAGE_DIRECT_DEBITS',
  DIRECT_DEBIT_EXPENSES_HISTORY = 'DIRECT_DEBIT_EXPENSES_HISTORY',
  NAV_IIC = 'NAV_IIC',
  WAIVE_LEGAL_DOCUMENTS_IIC = 'WAIVE_LEGAL_DOCUMENTS_IIC',
  VIEW_ACTIVE_REPOS = 'VIEW_ACTIVE_REPOS',
  PRIMARY_MARKET = 'PRIMARY_MARKET',
  FUTURES_SUMMARY = 'FUTURES_SUMMARY',
  DERIVATIVES_ACCOUNT_REQUEST_STATUS = 'DERIVATIVES_ACCOUNT_REQUEST_STATUS',
  DERIVATIVE_QUOTE = 'DERIVATIVE_QUOTE',
  DERIVATIVE_RANKING = 'DERIVATIVE_RANKING',
  WARRANT_QUOTE = 'WARRANT_QUOTE',
  WARRANT_RANKING = 'WARRANT_RANKING',
  VIEW_ACTIVE_DEPOSITS = 'VIEW_ACTIVE_DEPOSITS',
  RENEW_DEPOSIT = 'RENEW_DEPOSIT',
  REQUEST_CHECKBOOK = 'REQUEST_CHECKBOOK',
  CHECKBOOK_CONSULTATION = 'CHECKBOOK_CONSULTATION',
  ACTIVATION_CANCELLATION_CHECKBOOKS = 'ACTIVATION_CANCELLATION_CHECKBOOKS',
  // PERSONAL AREA - CONTACT DATA
  POSTAL_ADDRESS_PRODUCTS = 'POSTAL_ADDRESS_PRODUCTS',
  TAX_ADDRESS_PRODUCTS = 'TAX_ADDRESS_PRODUCTS',
}

export interface ExternalToolLinkResponse {
  type: TOOL_LINK_TYPE
  link: string
  authLink: string | null
}

export interface ExternalToolLinkParams {
  action: EXTERNAL_TOOL
  accountNumber?: string
  productId?: string
  instrumentCode?: string
}

export type TOOL_LINK_TYPE = 'CONTEXT_LINK_LIGHTHOUSE' | 'CONTEXT_LINK_CLASSIC' | 'CONTEXT_LINK_AFI'
